// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Jx","heading":"Kx"};